<template>
  <div class='total'>
    <div class="total-container"><i class="fa fa-users"></i><span class="text-total">{{translations.total}}</span><span class="number-total">{{chartData.total}}</span></div>
  </div>
</template>

<script>
export default {
  name: 'Total',
  props: ['chartData', 'translations'],
  data () {
    return { totalCount: 0 }
  },
  mounted () {
    // for (let i = 0; i < this.chartData.answersData.length; i++) {
    //   this.totalCount += this.chartData.answersData[i].result
    // }
  }
}
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped>

.total {
  text-align: center;
  margin: 1rem 0 2rem;
}

.total-container {
  display: inline-block;
}

.total-container span {
  margin-left: 5px;
}

.number-total {
  font-weight: 600;
}

</style>



// WEBPACK FOOTER //
// src/components/Total.vue